/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_CS as CS,
  rec_Componente_TS_84_83 as Componente_TS_84_83,
  rec_JSXRuntime as JSXRuntime,
  rec_Mr as Mr,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_SS as SS,
  rec_dS as dS,
  rec_jr as jr,
  rec_xS as xS,
  rec_yS as yS,
} from "../../runtime/index.jsx";
export function CalendarioFecha(e) {
  let t = (0, ReactCompiler.c)(42),
    { mesRef: n, setMesRef: r, value: i, onElegir: a, fueraDeRango: o } = e,
    s;
  t[0] === n ? (s = t[1]) : ((s = xS(n)), (t[0] = n), (t[1] = s));
  let c = s,
    l;
  t[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((l = dS(new Date())), (t[2] = l))
    : (l = t[2]);
  let u = l,
    f;
  t[3] !== n || t[4] !== r
    ? ((f = () => r(new Date(n.getFullYear(), n.getMonth() - 1, 1))),
      (t[3] = n),
      (t[4] = r),
      (t[5] = f))
    : (f = t[5]);
  let p;
  t[6] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((p = (0, JSXRuntime.jsx)(jr, {
        className: `h-4 w-4`,
      })),
      (t[6] = p))
    : (p = t[6]);
  let m;
  t[7] === f
    ? (m = t[8])
    : ((m = (
        <button
          type={`button`}
          aria-label={`Mes anterior`}
          onClick={f}
          className={`rounded-lg p-1 text-(--text) transition hover:bg-(--accent-bg) hover:text-(--accent)`}
          children={p}
        />
      )),
      (t[7] = f),
      (t[8] = m));
  let h = CS[n.getMonth()],
    _;
  t[9] === n ? (_ = t[10]) : ((_ = n.getFullYear()), (t[9] = n), (t[10] = _));
  let v;
  t[11] !== h || t[12] !== _
    ? ((v = (
        <span
          className={`text-sm font-medium capitalize text-(--text-h)`}
          children={[h, ` `, _]}
        />
      )),
      (t[11] = h),
      (t[12] = _),
      (t[13] = v))
    : (v = t[13]);
  let y;
  t[14] !== n || t[15] !== r
    ? ((y = () => r(new Date(n.getFullYear(), n.getMonth() + 1, 1))),
      (t[14] = n),
      (t[15] = r),
      (t[16] = y))
    : (y = t[16]);
  let b;
  t[17] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((b = <Mr className={`h-4 w-4`} />), (t[17] = b))
    : (b = t[17]);
  let x;
  t[18] === y
    ? (x = t[19])
    : ((x = (
        <button
          type={`button`}
          aria-label={`Mes siguiente`}
          onClick={y}
          className={`rounded-lg p-1 text-(--text) transition hover:bg-(--accent-bg) hover:text-(--accent)`}
          children={b}
        />
      )),
      (t[18] = y),
      (t[19] = x));
  let S;
  t[20] !== x || t[21] !== m || t[22] !== v
    ? ((S = (
        <div
          className={`mb-2 flex items-center justify-between`}
          children={[m, v, x]}
        />
      )),
      (t[20] = x),
      (t[21] = m),
      (t[22] = v),
      (t[23] = S))
    : (S = t[23]);
  let C, w;
  t[24] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((C = (
        <span
          className={`py-1 text-[10px] uppercase text-(--text)/60`}
          title={`Número de semana`}
          children={`sem`}
        />
      )),
      (w = SS.map(Componente_TS_84_83)),
      (t[24] = C),
      (t[25] = w))
    : ((C = t[24]), (w = t[25]));
  let T;
  if (t[26] !== o || t[27] !== n || t[28] !== a || t[29] !== c || t[30] !== i) {
    let e;
    (t[32] !== o || t[33] !== n || t[34] !== a || t[35] !== i
      ? ((e = (e) => (
          <React.Fragment
            key={dS(e[0])}
            children={[
              <span
                className={`flex items-center justify-center text-[10px] tabular-nums text-(--text)/60`}
                children={yS(e[0])}
              />,
              e.map((e) => {
                let t = dS(e),
                  r = e.getMonth() === n.getMonth(),
                  s = t === i,
                  c = o(t);
                return (
                  <button
                    key={t}
                    type={`button`}
                    disabled={c}
                    onClick={() => a(t)}
                    className={`rounded-lg py-1.5 text-xs transition ${s ? `bg-(--accent) font-medium text-(--accent-fg)` : c ? `cursor-not-allowed text-(--text)/25` : r ? `text-(--text-h) hover:bg-(--accent-bg)` : `text-(--text)/50 hover:bg-(--accent-bg)`} ${t === u && !s ? `ring-1 ring-(--accent-border)` : ``}`}
                    children={e.getDate()}
                  />
                );
              }),
            ]}
          />
        )),
        (t[32] = o),
        (t[33] = n),
        (t[34] = a),
        (t[35] = i),
        (t[36] = e))
      : (e = t[36]),
      (T = c.map(e)),
      (t[26] = o),
      (t[27] = n),
      (t[28] = a),
      (t[29] = c),
      (t[30] = i),
      (t[31] = T));
  } else T = t[31];
  let E;
  t[37] === T
    ? (E = t[38])
    : ((E = (
        <div
          className={`grid grid-cols-[1.6rem_repeat(7,1fr)] gap-0.5 text-center`}
          children={[C, w, T]}
        />
      )),
      (t[37] = T),
      (t[38] = E));
  let D;
  return (
    t[39] !== S || t[40] !== E
      ? ((D = <JSXRuntime.Fragment children={[S, E]} />),
        (t[39] = S),
        (t[40] = E),
        (t[41] = D))
      : (D = t[41]),
    D
  );
}
